import { CONTEXT } from './constants';

export const enableEditMode = isEditMode => ({
  type: CONTEXT.ENABLE_EDIT_MODE,
  payload: isEditMode,
});
